import { Questionnaire } from "@/types/questionnaire/models"

export interface SectionAnswersFilled {
  [sectionId: string]: number
}

export function reduceNumTotalQuestions(data: Questionnaire): number {
  return data.sections.reduce((total, section) => {
    return total + section.responsePairs.length
  }, 0)
}
